/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Location = props => (
  <svg viewBox="0 0 20 20" width="1em" height="1em" {...props}>
    <path d="M10 3C8.1 3 6.5 4.6 6.5 6.5c0 1.6 2.3 4.4 3.2 5.4.2.2.5.2.7 0 .9-1 3.2-3.9 3.2-5.4C13.5 4.6 11.9 3 10 3zm0 4.7c-.6 0-1.2-.5-1.2-1.2s.6-1.2 1.2-1.2 1.2.5 1.2 1.2-.6 1.2-1.2 1.2zM2.6 9c-.4.1-.6.5-.6.8v7c0 .3.3.5.6.4l3.8-1.7V9c-.2-.5-.4-.9-.5-1.3L2.6 9zm7.4 4c-.4 0-.8-.2-1-.5-.5-.6-1.1-1.4-1.7-2.1v5.1l5.3 1.8v-6.8c-.5.8-1.1 1.5-1.7 2.1-.1.2-.5.4-.9.4zm7.4-5.5l-3.8 1.7v8l3.9-1.6c.3-.1.6-.5.6-.8v-7c-.1-.2-.4-.4-.7-.3z" />
  </svg>
);

export default extendIcon(Location);
